export default "__VITE_ASSET__DDjpBw0P__"